var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThoughtfulRecommendations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 21.084V14.8757C8.66675 13.2291 9.32084 11.65 10.4851 10.4857C11.6494 9.32145 13.2285 8.66736 14.8751 8.66736H21.0834",
    stroke: "#104145",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 45.9174V52.1257C8.66675 53.7722 9.32084 55.3514 10.4851 56.5156C11.6494 57.6799 13.2285 58.334 14.8751 58.334H21.0834",
    stroke: "#104145",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9167 8.66736H52.1251C53.7716 8.66736 55.3507 9.32145 56.515 10.4857C57.6793 11.65 58.3334 13.2291 58.3334 14.8757V21.084",
    stroke: "#104145",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9167 58.334H52.1251C53.7716 58.334 55.3507 57.6799 56.515 56.5156C57.6793 55.3514 58.3334 53.7722 58.3334 52.1257V45.9174",
    stroke: "#104145",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 26.0831C23.5456 25.4824 24.2489 25.0053 25.0249 24.6795C25.801 24.3538 26.6341 24.186 27.4757 24.186C28.3174 24.186 29.1505 24.3538 29.9266 24.6795C30.7026 25.0053 31.4059 25.4824 31.9954 26.0831L33.5009 27.2937L35.053 26.0645C35.6421 25.4704 36.3433 24.9992 37.116 24.6784C37.8886 24.3575 38.7173 24.1933 39.5539 24.1953C40.3906 24.1973 41.2185 24.3655 41.9896 24.6901C42.7607 25.0147 43.4596 25.4893 44.0458 26.0862C45.2457 27.3075 45.9179 28.9512 45.9179 30.6633C45.9179 32.3754 45.2457 34.019 44.0458 35.2404L33.5009 45.9187L22.9561 35.2404C21.7553 34.0189 21.0824 32.3746 21.0824 30.6617C21.0824 28.9489 21.7553 27.3046 22.9561 26.0831Z",
    fill: "#104145",
    stroke: "#104145",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtfulRecommendations);
export default __webpack_public_path__ + "static/media/Thoughtful-Recommendations.e5f86096664ea52e4da843177af778d5.svg";
export { ForwardRef as ReactComponent };